module.exports = __webpack_public_path__ + "assets/img/tianxia.c10050d2.jpg";